import { isValidTeamMembersSearchQuery } from "@src/constants/team-constants";
import { useValidatedSearchQuery } from "@hooks/use-validated-search-query";

/** Custom hook to manage the team members search query */
export function useTeamMembersSearchQuery() {
  return useValidatedSearchQuery(isValidTeamMembersSearchQuery);
}